import React from 'react'
import {
  KYCDetailsUploadedDocTableDataType,
  uploadDocumentsArrayDataType,
} from '../KYCDetailsDataType'

const KYCDetailsUploadedDocTable = ({
  setUploadDocuments,
  uploadDocuments,
  APIDataKYCAccountDocType,
  setKYCAccountDocType,
  KYCAccountDocType,
}: KYCDetailsUploadedDocTableDataType) => {
  // function to delete the decument (onclick of delete button)
  const handleDeleteDocument = (document: uploadDocumentsArrayDataType) => {
    setUploadDocuments(
      uploadDocuments.filter(
        (uploadDocument) =>
          uploadDocument.account_kyc_document_type_uuid !== document.account_kyc_document_type_uuid
      )
    )
    const doc = APIDataKYCAccountDocType.find(
      (obj) => obj.account_kyc_document_type_uuid === document.account_kyc_document_type_uuid
    )
    if (doc) {
      setKYCAccountDocType([...KYCAccountDocType, doc])
    }
  }
  return (
    <div className='mx-6'>
      {/* begin::Table */}
      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
        {/* begin::Table head */}
        <thead>
          <tr className='fw-bold text-muted'>
            <th className='max-w-50px'>KYC Document type name</th>
            <th className='max-w-50px'>File name</th>
            <th className='max-w-50px'>Actions</th>
          </tr>
        </thead>
        {/* end::Table head */}
        {/* begin::Table body */}
        <tbody>
          {uploadDocuments?.map((property, index: number) => {
            return (
              <tr key={index}>
                <td className='max-w-200px'>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    {property.documentTypeName}
                  </span>
                </td>
                <td className='max-w-100px'>
                  <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                    {property.fileName}
                  </span>
                </td>
                <td className='max-w-150px'>
                  <div className='d-flex flex-shrink-0'>
                    <button
                      type='button'
                      className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                      onClick={() => handleDeleteDocument(property)}
                    >
                      <i className='bi bi-trash-fill fs-3' title='Delete documents'></i>
                    </button>
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
        {/* end::Table body */}
      </table>
      {/* end::Table */}
    </div>
  )
}

export default KYCDetailsUploadedDocTable
